import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
// Importamos el CSS usando la sintaxis normal (no como módulo)
import './index.css';
import { initAutoUpdate } from './autoUpdate';
import { registerPwa } from './pwa';

// Los <input type="number"> cambian de valor con la RUEDA del mouse (si están
// enfocados) y con las flechas ↑/↓ — causó cortes de caja con 39.97 en vez de 40
// en la agenda dental (2-jul). Se neutraliza globalmente: la rueda suelta el foco
// (el scroll sigue moviendo la página) y las flechas no hacen stepping.
document.addEventListener('wheel', () => {
  const el = document.activeElement;
  if (el instanceof HTMLInputElement && el.type === 'number') el.blur();
}, { capture: true, passive: true });
document.addEventListener('keydown', (e) => {
  const el = e.target;
  if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') &&
      el instanceof HTMLInputElement && el.type === 'number') {
    e.preventDefault();
  }
}, true);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Auto-actualización sin botón: la pestaña se recarga sola al detectar un deploy nuevo.
initAutoUpdate();

// Registra el service worker mínimo (panel instalable como app).
registerPwa();